import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { Notification } from '../../../../config/Global';
const { Title } = Typography;

const DeletePropertyComponent = observer((props) => {
	const { visible, onClose, merchantId } = props;
	const [saving, setSaving] = useState();
	const { ACCOMMODATION } = useStore();
	const { propertyDetail, roomCategoryDetail } = ACCOMMODATION;
	const deleteChangeProperty = () => {
		setSaving(true);
		let propertyPayload = {
			id: visible.id.toString(),
			versionNo: visible.versionNo,
		};
		ACCOMMODATION.deleteProperty({
			...propertyPayload,
		})
			.then((msg) => {
				Notification.success({
					message: Message().CRUD.DELETE(
						'Property and Room Category'
					),
				});
				ACCOMMODATION.getMerchantAccomodation(merchantId.merchantId);
				onClose();
			})
			.catch((e) => {
				Notification.error({
					message: 'Something Wrong',
				});
			})
			.finally(() => setSaving(false));
	};

	return (
		<Modal
			title="Delete Property"
			onCancel={onClose}
			open={visible}
			destroyOnClose
			width={'450px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						loading={saving}
						onClick={deleteChangeProperty}
					>
						Delete
					</Button>
					<Button key={2} onClick={onClose}>
						Cancel
					</Button>
				</div>
			}
		>
			<Title level={5}>
				Are you sure you want to
				<b> delete {' ' + visible?.propertyName + ' '}</b>
				property?
			</Title>
		</Modal>
	);
});

export default DeletePropertyComponent;
